// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"044b731e","807":"7f329382","925":"0edaae6a"}[chunkId] + ".js";
};